import React, { useState } from "react";
import { QuestionText, AnswerField } from "./Fields";
import InfoButton from "./InfoButton";

import "./Question.scss";

export default function Question({ question }) {
	const [isPopUpWindowOpen, setIsPopUpWindowOpen] = useState(false);

	const onToggle = () => {
		setIsPopUpWindowOpen((state) => !state);
	};

	return (
		<div className="question">
			<QuestionText description={question.description}>
				{question.text}
				{question.information && (
					<InfoButton
						open={isPopUpWindowOpen}
						information={question.information}
						onToggle={onToggle}
						isHTML={false}
					/>
				)}
			</QuestionText>
			<AnswerField question={question} />
		</div>
	);
}
